import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { utcToZonedTime } from 'date-fns-tz';
import { logError } from 'commons/logger';
import scrollIntoViewUtil from 'commons/scrollIntoViewUtil';
import { PDP_DECIDELATER_TAB_ID, IATA_LOS_ANGELES_TIMEZONE } from 'commons/constants';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import usePDPPrice from 'data-hooks/usePDPPrice';
import PDPDecideLaterPromoUI from './PDPDecideLaterPromoUI';
import usePDPOptions from '../state/context/usePDPOptions';
const PDPDecideLaterPromo = () => {
  const $ = _c(17);
  const {
    loading,
    data: priceData
  } = usePDPPrice();
  const {
    data: t0
  } = usePDPOptions();
  const {
    upholsteryOptionId,
    hasSingleOptionType
  } = t0 === undefined ? {} : t0;
  const {
    isEFGInternal
  } = useProductEFGInternalStatus();
  const [storedLocalStorageObj, setLocalStorageObj] = useLocalStorage("PDPDecideLaterPromo");
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  let t1;
  let t2;
  if ($[0] !== priceData || $[1] !== setLocalStorageObj || $[2] !== storedLocalStorageObj) {
    t1 = () => {
      if (!priceData || !(priceData.promotion?.discount > 0) || storedLocalStorageObj && storedLocalStorageObj.endDate === priceData.promotion?.endDate) {
        return;
      }
      if (!storedLocalStorageObj) {
        setLocalStorageObj({
          hide: false,
          endDate: priceData.promotion.endDate
        });
        return;
      }
      const copyStoredLocalStorageObj = {
        ...storedLocalStorageObj
      };
      copyStoredLocalStorageObj.endDate = priceData.promotion.endDate;
      copyStoredLocalStorageObj.hide = false;
      setLocalStorageObj(copyStoredLocalStorageObj);
    };
    t2 = [storedLocalStorageObj, priceData, setLocalStorageObj];
    $[0] = priceData;
    $[1] = setLocalStorageObj;
    $[2] = storedLocalStorageObj;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (isEFGInternal || hasSingleOptionType || !upholsteryOptionId || !priceData || !(priceData.promotion?.discount > 0) || storedLocalStorageObj?.hide === true) {
    return null;
  }
  const minPromotion = priceData.promotion.discount;
  const isTieredPromotion = priceData.promotion.tiers?.length > 1;
  let t3;
  if ($[5] !== isTieredPromotion || $[6] !== priceData.promotion.tiers) {
    t3 = isTieredPromotion ? priceData.promotion.tiers.reduce(_temp, 0) : null;
    $[5] = isTieredPromotion;
    $[6] = priceData.promotion.tiers;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const maxTierPromotion = t3;
  const buttonText = maxTierPromotion ? `Lock in up to ${maxTierPromotion}% off now` : `Lock in ${minPromotion}% off now`;
  let t4;
  if ($[8] !== priceData.promotion.endDate) {
    let zonedEndDate = null;
    ;
    try {
      zonedEndDate = utcToZonedTime(priceData.promotion.endDate, IATA_LOS_ANGELES_TIMEZONE);
    } catch (t5) {
      const e = t5;
      logError(e);
    }
    t4 = zonedEndDate ? `${zonedEndDate.getMonth() + 1}/${zonedEndDate.getDate()}` : null;
    $[8] = priceData.promotion.endDate;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const formattedEndDate = t4;
  let t5;
  if ($[10] !== buttonText || $[11] !== formattedEndDate || $[12] !== loading || $[13] !== priceData.promotion.endDate || $[14] !== setLocalStorageObj || $[15] !== setPdpSelectedCustomizerTab) {
    t5 = formattedEndDate ? <PDPDecideLaterPromoUI loading={loading} heading="Buy Now, Decide Later" subheading={`(Sale ends ${formattedEndDate})`} buttonText={buttonText} onButtonClick={() => {
      setPdpSelectedCustomizerTab(PDP_DECIDELATER_TAB_ID);
      scrollIntoViewUtil("[data-xc=\"PDPDesktop\"]");
    }} onClose={() => {
      setLocalStorageObj({
        hide: true,
        endDate: priceData.promotion.endDate
      });
    }} /> : null;
    $[10] = buttonText;
    $[11] = formattedEndDate;
    $[12] = loading;
    $[13] = priceData.promotion.endDate;
    $[14] = setLocalStorageObj;
    $[15] = setPdpSelectedCustomizerTab;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default PDPDecideLaterPromo;
function _temp(maxDisc, tier) {
  if (tier.discount > maxDisc) {
    return tier.discount;
  }
  return maxDisc;
}